/**
 * Utilitaires de connectivité réseau.
 */

import { showToast } from './dom.js';

/**
 * Vérifie si l'application est en ligne.
 * @returns {boolean}
 */
export function isOnline() {
  return navigator.onLine;
}

/**
 * Vérifie que l'on est en ligne, sinon affiche un toast et retourne false.
 * À appeler avant toute opération CRUD.
 * @param {string} [message] - Message personnalisé
 * @returns {boolean}
 */
export function requireOnline(message = 'Internet requis pour cette action') {
  if (!isOnline()) {
    showToast(message, 3000, 'error');
    return false;
  }
  return true;
}

let _onlineCallbacks = [];
let _offlineCallbacks = [];
let _listenersBound = false;

/**
 * Enregistre des callbacks pour les changements de connectivité.
 */
export function onConnectivityChange({ onOnline, onOffline } = {}) {
  if (onOnline) _onlineCallbacks.push(onOnline);
  if (onOffline) _offlineCallbacks.push(onOffline);

  if (!_listenersBound) {
    window.addEventListener('online', () => _onlineCallbacks.forEach((cb) => cb()));
    window.addEventListener('offline', () => _offlineCallbacks.forEach((cb) => cb()));
    _listenersBound = true;
  }
}
